import Debug from 'debug'

export const debug = Debug('state-router')
